import { useCallback } from 'react';
import { isRouteBetaFeatureEnabled, useBetaFeatures } from '@/entities/beta-feature';
import { PermissionCode, usePermissionsSet } from '@/entities/profile';
import { RouteConfig } from '@/shared/lib';
import { collectGroupPermissions } from '../utils';

/**
 * Предикат видимости группы меню для текущего пользователя: любое из разрешений её пунктов
 * (группа из одних пунктов без разрешения видна всем) и её собственная бета-функция.
 *
 * Одно правило на все места, где решается, что пользователю видно в меню: сама группа
 * (`AppSidebarGroup`) и выбор адреса по умолчанию — первого видимого пункта меню. Иначе адрес
 * по умолчанию уводил бы в раздел, которого у пользователя в меню нет.
 */
export const useIsGroupVisible = () => {
  const permissions = usePermissionsSet();
  const { data } = useBetaFeatures();

  return useCallback(
    (route: RouteConfig) => {
      const codes = collectGroupPermissions(route).filter((code): code is PermissionCode => !!code);
      const allowView = codes.length === 0 || codes.some((code) => permissions.has(code));

      return allowView && isRouteBetaFeatureEnabled(data?.features, route.betaFeature);
    },
    [permissions, data],
  );
};
